var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"px-0",attrs:{"text":"","id":"btnGoTo","min-width":_vm.mobile ? '10' : ''},on:{"click":_vm.action}},[_c('v-icon',[_vm._v("menu")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }